import React, { useState } from 'react';
import { ChevronRight, FileText, Home } from 'lucide-react';
import HeaderTitle from '../components/HeaderTitle';
import { Link } from 'react-router-dom';

const CatalogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('ultrasonic');

  const categories = {
    ultrasonic: {
      name: 'Ultrasonic Machines',
      pdfs: [
        { name: 'Ultrasonic Machine Catalogue', file: '/Ultronics UCM Catalogue.pdf' }
      ]
    },
    special: {
      name: 'Special Purpose Machines',
      pdfs: [
        { name: 'Special Purpose Machine Catalogue', file: '/Ultronics Special Purpose Machines.pdf' }
      ]
    }
  };

  return (
    <>
    <HeaderTitle title={"E-Catalogue"}/> 
    <section>
    <div className="mx-auto max-w-screen-xl px-4 py-1 sm:px-6 sm:py-4 lg:px-8">
    <nav className="flex items-center space-x-1 text-sm text-gray-500 mb-0">
        <Link to="/" className="hover:text-gray-700 flex items-center">
          <Home className="w-4 h-4" />
        </Link>
        <ChevronRight className="w-4 h-4" />
        <span className="text-gray-900 font-medium">E-catalogue</span>
      </nav>
      </div>
    </section>
    
    <div className="flex min-h-screen bg-gray-100">

      {/* Left Sidebar */}
      <div className=" w-36 md:w-64 bg-white shadow-lg">
        <div className="p-4">
          <h2 className="text-lg font-bold mb-4 text-gray-800">Categories</h2>
          <nav className="space-y-2">
            <button
              className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
                selectedCategory === 'ultrasonic'
                  ? 'bg-blue-100 text-blue-700'
                  : 'hover:bg-gray-100'
              }`}
              onClick={() => setSelectedCategory('ultrasonic')}
            >
              Ultrasonic Machines
            </button>
            <button
              className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
                selectedCategory === 'special'
                  ? 'bg-blue-100 text-blue-700'
                  : 'hover:bg-gray-100'
              }`}
              onClick={() => setSelectedCategory('special')}
            >
              Special Purpose Machines
            </button>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 p-8">
        <h1 className="text-2xl font-bold mb-6 text-gray-900">
          {categories[selectedCategory].name}
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories[selectedCategory].pdfs.map((pdf, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center space-x-3 mb-3">
                <FileText className="text-blue-600" size={24} />
                <h3 className="font-medium text-gray-800">{pdf.name}</h3>
              </div>
              <a
                href={pdf.file}
                download
                aria-label={"Download "+pdf.name}
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Download PDF
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
};

export default CatalogPage;